// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const simisage: PokeData = {
  "id": 512,
  "name": "simisage",
  "height": 11,
  "weight": 305,
  "base_experience": 174,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "leer",
    "lick",
    "fury-swipes",
    "seed-bomb"
  ],
  "moves": [
    "leer",
    "lick",
    "vine-whip",
    "leaf-tornado",
    "solar-beam",
    "flower-rush",
    "grassy-terrain",
    "wood-hammer",
    "bullet-seed",
    "power-whip",
    "synthesis",
    "overgrowth",
    "razor-leaf"
  ],
  "evolution_chain": {
    "id": 262,
    "item": null,
    "species": [
      {
        "name": "pansage",
        "order": 512,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "simisage",
        "order": 513,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 511,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 151,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
